import styled from 'styled-components/macro'

const SymbolChip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px;
  background: linear-gradient(0deg, #ffffff, #ffffff), #262626;
  opacity: 0.64;
  border-radius: 4px;
`

export default SymbolChip
